import axios from 'axios';
import { API_BASE_URL } from '../config';

export default class QueueService {
  static getQueueDashboardUrl(pathname = '/api/v2/admin/queues/ui') {
    return `${API_BASE_URL.replace(/\/api\/?$/, '')}${pathname}`;
  }

  static async requestQueueAccess() {
    const userString = localStorage.getItem('admin');
    const user = JSON.parse(userString);

    return axios.post(
      `${API_BASE_URL}/v2/admin/queues/access`,
      {},
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          Authorization: `Bearer ${user?.accessToken || ''}`,
        },
      },
    );
  }

  static async clearQueueAccess() {
    const userString = localStorage.getItem('admin');
    const user = JSON.parse(userString);

    return axios.post(
      `${API_BASE_URL}/v2/admin/queues/logout`,
      {},
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          Authorization: `Bearer ${user?.accessToken || ''}`,
        },
      },
    );
  }
}
